import { useTranslation } from 'react-i18next';
import { ClbModal } from '@celebration/react/ClbModal/ClbModal';
import { useCallback } from 'react';
import ICountryConfirmationModalProps from '../../interfaces/ICountryConfirmationModalProps';
import AuthContext from '../../../../app/contexts/auth';

function CountryConfirmationModal({
    opened,
    country,
    closeModalCallback,
}: Readonly<ICountryConfirmationModalProps>) {
    const { t } = useTranslation();
    const { refreshIdentityToken } = AuthContext.useAuth();

    const changeCountry = useCallback(() => {
        refreshIdentityToken(country);
        closeModalCallback();
    }, [country, refreshIdentityToken, closeModalCallback]);

    return (
        <ClbModal
            open={opened}
            title={t('ChangeCountry')}
            description={t('ChangeCountryContent')}
            type="default"
            onClose={() => closeModalCallback()}
            data-testid="change-country-modal"
            itemsFooter={[
                {
                    key: 'change-country-approve-button',
                    id: 'change-country-approve-button',
                    label: t('ChangeCountryApprove'),
                    title: t('ChangeCountryApprove'),
                    'data-testid': 'modal-approve-button',
                    onClick: () => changeCountry(),
                    role: 'button',
                    size: 'md',
                },
                {
                    key: 'change-country-cancel-button',
                    id: 'change-country-cancel-button',
                    label: t('Cancelar'),
                    title: t('ChangeCountryReprove'),
                    'data-testid': 'modal-cancel-button',
                    onClick: () => closeModalCallback(),
                    role: 'button',
                    size: 'md',
                    styleType: 'secondary',
                },
            ]}
        />
    );
}

export default CountryConfirmationModal;
